import { S, Icon } from '../regureStyles';

const OverviewTab = ({ regions }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 20 }}>
      {regions.map(region => (
        <div key={region.id} style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 12, padding: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: region.primary ? `${S.burgundy}15` : S.bgCard,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon name='globe' size={20} color={region.primary ? S.burgundy : S.textMuted} />
              </div>
              <div>
                <div style={{ fontWeight: 600, color: S.textPrimary, fontSize: 15 }}>{region.name}</div>
                <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>
                  {region.primary ? <span style={{ color: S.burgundy, fontWeight: 500 }}>Primary</span> : <span style={{ color: S.textMuted }}>Secondary</span>}
                </div>
              </div>
            </div>
            <span
              style={{
                padding: '3px 10px',
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 500,
                background: region.status === 'active' ? '#ecfdf5' : '#fffbeb',
                color: region.status === 'active' ? S.success : S.warning,
              }}
            >
              {region.status === 'active' ? 'Active' : 'Standby'}
            </span>
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 6 }}>Storage Capacity Used</div>
            <div style={{ height: 6, background: S.bgCard, borderRadius: 3, overflow: 'hidden' }}>
              <div
                style={{
                  height: '100%',
                  width: `${region.capacity}%`,
                  background: region.capacity > 80 ? S.warning : S.burgundy,
                  borderRadius: 3,
                  transition: 'width 0.3s',
                }}
              />
            </div>
            <div style={{ fontSize: 12, color: S.textMuted, marginTop: 4, textAlign: 'right' }}>{region.capacity}% used</div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 8 }}>Data Types</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(region.dataTypes || []).map(dt => (
                <span
                  key={dt}
                  style={{ fontSize: 11, padding: '3px 8px', background: S.bgCard, border: `1px solid ${S.borderLight}`, borderRadius: 4, color: S.textSecondary }}
                >
                  {dt}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 8 }}>Compliance Frameworks</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(region.compliance || []).map(c => (
                <span
                  key={c}
                  style={{
                    fontSize: 11,
                    padding: '3px 8px',
                    background: `${S.info}10`,
                    color: S.info,
                    border: `1px solid ${S.info}30`,
                    borderRadius: 4,
                    fontWeight: 500,
                  }}
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewTab;
